import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import DashboardScreen from "../Views/DashboardModule/DashboardScreen";
import ProductScreen from "../Views/ProductsModule/ProductScreen";
import AddProduct from "../Views/ProductsModule/AddProduct";
import ProductTable from "../Views/ProductsModule/AllProducts";
import Units from "../Views/ProductsModule/UnitScreen";
import Brand from "../Views/ProductsModule/ProductBrandsScreen";
// import ProductDescription from "../Views/ProductsModule/ProductDescription";
import Order from "../Views/OrderModule/Order";
import OrderScreen from "../Views/OrderModule/OrderScreen";
import OrderScreenDetail from "../Views/OrderModule/OrderDetailsScreen";
import CreateOrderScreen from "../Views/OrderModule/CreateOrder";
import AcceptOrderScreen from "../Views/OrderModule/AcceptOrder";
import GenerateBillScreen from "../Views/OrderModule/Components/OrderDetailsComponents/GenerateBillScreen";
import VoucherScreen from "../Views/VoucherModule/VoucherScreen";
import SellasViewAddProduct from "../Views/ProductsModule/SellAsViewPack";
import AddVoucher from "../Views/VoucherModule/AddCommonVoucher";
import Poster from "../Views/VoucherModule/Poster";
import ViewVoucher from "../Views/VoucherModule/ViewVoucher";
import CustomerScreen from "../Views/CustomerModule/CustomerScreen";
import Location from "../Views/CustomerModule/Listing";
import CustomerRequest from "../Views/CustomerModule/CustomerRequestScreen";
import ViewCustomer from "../Views/CustomerModule/ViewCustomer";
import Settings from "../Views/SettingsModule/Settings";
import ViewReceipt from "../Views/ReceiptModule/ViewReceipt";
import AddReceipt from "../Views/ReceiptModule/AddReceipt";
import ReceiptScreen from "../Views/ReceiptModule/Receipt";
import AddCustomer from "../Views/CustomerModule/AddCustomer";
import ReportScreen from "../Views/ReportModule/ReportScreen";
import OutstandingBalanceScreen from "../Views/ReportModule/OutstandingBalanceScreen";
import Ledger from "../Views/ReportModule/Ledger";
import GSTReports from "../Views/ReportModule/GSTReports";
import User from "../Views/UserManagement/User";
import Role from "../Views/UserManagement/Role";
import CreateNewRole from "../Views/UserManagement/CreateNewRole";
import SellAsViewScreen from "../Views/ProductsModule/SellAsViewScreen";
import ProductCategory from "../Views/ProductsModule/ProductCategory";
import LoginScreen from "../Views/AuthModule/LoginScreen";
import EditCustomer from "../Views/CustomerModule/EditCustomer";
import LedgerDetailsScreen from "../Views/ReportModule/LedgerDetailsScreen";
import GSTReportDetailsScreen from "../Views/ReportModule/GSTReportDetailsScreen";
import EditReceipt from "../Views/ReceiptModule/EditReceipt";
import CustomerVoucher from "../Views/VoucherModule/AddVoucher";
import SettingsScreen from "../Views/SettingsModule/SettingsScreeen";
import PersistLogin from "./services/PersistLogin";
import Page404 from "../Views/Error/404page";
import useAuth from "../Views/AuthModule/hooks/useAuth";
import EditRole from "../Views/UserManagement/EditRole";
import LoadingScreen from "../Common/LoadingScreen";
import ViewCustomerDetails from "../Views/CustomerModule/ViewCustomerDetails";
import CustomerRequestDetails from "../Views/CustomerModule/CustomerRequestDetails";
import SideBar from "../Common/SideBar";
// Import Finance Module
import {
  Purchases,
  Salaries,
  Expenses,
  FinanceScreen,
} from "../Views/FinanceModule";

// Import Loyalty Module
import {
  LoyaltyScreen,
  LoyaltyPoints,
  PointsHistory,
  RedemptionRules,
} from "../Views/LoyaltyModule";
import ProductDetails from "../Views/ProductsModule/ProductDetailsScreen";
import ViewReceiptDetail from "../Views/ReceiptModule/Components/ViewReceiptDetail";
import CustomerDetailView from "../Views/ReportModule/Components/OutstandingBalanceComponents/CustomerDetailView";

// Import Billing Module
import BillingScreen from "../Views/BillingModule/BillingScreen";
import InvoiceView from "../Views/BillingModule/Components/InvoiceView";

// Import the new ViewAllNotifications screen
import ViewAllNotifications from "../Common/ViewAllNotifications";

// Import Purchase Module
import PurchaseScreen from "../Views/PurchaseModule/PurchaseScreen";
import PurchaseOrder from "../Views/PurchaseModule/PurchaseOrder";
import PurchaseInward from "../Views/PurchaseModule/PurchaseInward";
import PurchaseReturn from "../Views/PurchaseModule/PurchaseReturn";
import CreatePurchaseOrder from "../Views/PurchaseModule/CreatePurchaseOrder";
import CreatePurchaseInward from "../Views/PurchaseModule/CreatePurchaseInward";
import CreatePurchaseReturn from "../Views/PurchaseModule/CreatePurchaseReturn";

// Import Production Module
import ProductionScreen from "../Views/ProductionModule/ProductionScreen";
import Jobslips from "../Views/ProductionModule/Jobslips";
import DesignRecipe from "../Views/ProductionModule/DesignRecipe";
import ViewDesignRecipe from "../Views/ProductionModule/ViewDesignRecipe";
import Karigar from "../Views/ProductionModule/Karigar";
import CreateJobslip from "../Views/ProductionModule/CreateJobslip";
import ViewJobslip from "../Views/ProductionModule/ViewJobslip";
import TransferJobslip from "../Views/ProductionModule/TransferJobslip";
import ReceiveJobslip from "../Views/ProductionModule/ReceiveJobslip";

// Import Material Module
import Material from "../Views/ProductionModule/Material";
import AddMaterial from "../Views/ProductionModule/AddMaterial";
import ViewMaterial from "../Views/ProductionModule/ViewMaterial";

// Layout component to wrap all authenticated routes
const MainLayout = () => {
  return (
    <div className="flex">
      <SideBar />
      <div className="flex-1 min-w-0 overflow-x-hidden">
        <Outlet />
      </div>
    </div>
  );
};

const AuthRoute = () => {
  const { isAuthenticated } = useAuth();

  // Redirect authenticated users away from auth pages
  return isAuthenticated ? <Navigate to="/" /> : <Outlet />;
};

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default function MainNavigator({ useExistingRouter = false }) {
  const NavigatorContent = () => (
    <Routes>
      {/* Public routes */}
      <Route element={<AuthRoute />}>
        <Route path="/login" element={<LoginScreen />} />
      </Route>

      {/* Protected routes */}
      <Route element={<PersistLogin />}>
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route index element={<DashboardScreen />} />
            <Route path="/products" element={<ProductScreen />}>
              <Route index element={<ProductTable />} />
              <Route path="addproduct" element={<SellAsViewScreen />}>
                <Route index element={<AddProduct />} />
                <Route path="sellAs" element={<SellasViewAddProduct />} />
              </Route>
              <Route path="addProducts" element={<SellAsViewScreen />}>
                <Route index element={<AddProduct />} />
                <Route path="sellAs" element={<SellasViewAddProduct />} />
              </Route>
              <Route path="units" element={<Units />} />
              <Route path="category" element={<ProductCategory />} />
              <Route path="brands" element={<Brand />} />
              <Route path="view/:id" element={<ProductDetails />} />
            </Route>

            <Route path="/orders" element={<OrderScreen />}>
              <Route index element={<Order />} />
              <Route
                path="orderdetail/:orderId"
                element={<OrderScreenDetail />}
              />
              <Route
                path=":orderId/generate-bill"
                element={<GenerateBillScreen />}
              />
              <Route path=":orderId/view-bill" element={<InvoiceView />} />
              <Route path="createOrder" element={<CreateOrderScreen />} />
              <Route path="accept" element={<AcceptOrderScreen />} />
            </Route>

            {/* Billing Routes */}
            <Route path="/billing" element={<BillingScreen />}>
              <Route path="invoice/:invoiceId" element={<InvoiceView />} />
              <Route path="invoice/sample" element={<InvoiceView />} />
            </Route>

            <Route path="/voucher" element={<VoucherScreen />}>
              <Route index element={<AddVoucher />} />
              <Route path="viewvoucher" element={<ViewVoucher />} />
              <Route path="poster" element={<Poster />} />
            </Route>

            <Route path="/customer" element={<CustomerScreen />}>
              <Route index element={<CustomerRequest />} />
              <Route path="request" element={<CustomerRequest />} />
              <Route
                path="request/:requestId"
                element={<CustomerRequestDetails />}
              />
              <Route path="viewcustomer" element={<ViewCustomer />} />
              <Route path="location" element={<Location />} />
              <Route path="edit" element={<EditCustomer />} />
              <Route path="addcustomer" element={<AddCustomer />} />
              <Route
                path="view/:customerId"
                element={<ViewCustomerDetails />}
              />
              <Route path="addvoucher" element={<CustomerVoucher />} />
            </Route>

            <Route path="/receipt" element={<ReceiptScreen />}>
              <Route index element={<ViewReceipt />} />
              <Route path="addreceipt" element={<AddReceipt />} />
              <Route path="edit/:receiptId" element={<EditReceipt />} />
              <Route path="view/:receiptId" element={<ViewReceiptDetail />} />
            </Route>

            {/* Finance Module Routes */}
            <Route path="/finance" element={<FinanceScreen />}>
              <Route index element={<Purchases />} />
              <Route path="purchases" element={<Purchases />} />
              <Route path="salaries" element={<Salaries />} />
              <Route path="expenses" element={<Expenses />} />
            </Route>

            {/* Loyalty Module Routes */}
            <Route path="/loyalty" element={<LoyaltyScreen />}>
              <Route index element={<LoyaltyPoints />} />
              {/* <Route path="points" element={<LoyaltyPoints />} /> */}
              <Route path="history" element={<PointsHistory />} />
              <Route path="redemption" element={<RedemptionRules />} />
            </Route>

            <Route path="/usermanagement" element={<ReportScreen />}>
              <Route index element={<User />} />
              {/* <Route path="user" element={<User />} /> */}
              <Route path="roles" element={<Role />} />
              <Route path="createrole" element={<CreateNewRole />} />
              <Route path="editrole" element={<EditRole />} />
            </Route>

            <Route path="/report" element={<ReportScreen />}>
              <Route index element={<OutstandingBalanceScreen />} />
              <Route
                path="outstanding-balance"
                element={<OutstandingBalanceScreen />}
              />
              <Route
                path="outstanding-balance/view/:customerId"
                element={<CustomerDetailView />}
              />
              <Route path="ledger" element={<Ledger />} />
              <Route
                path="ledger/:customerId"
                element={<LedgerDetailsScreen />}
              />
              <Route path="gstreport" element={<GSTReports />} />
              <Route
                path="gstreporttable"
                element={<GSTReportDetailsScreen />}
              />
            </Route>

            <Route path="/settings" element={<SettingsScreen />}>
              <Route index element={<Settings />} />
            </Route>

            <Route path="/notifications" element={<ViewAllNotifications />} />

            {/* Purchase Module Routes */}
            <Route path="/purchase" element={<PurchaseScreen />}>
              <Route index element={<PurchaseOrder />} />
              <Route path="orders" element={<PurchaseOrder />} />
              <Route path="orders/create" element={<CreatePurchaseOrder />} />
              <Route path="inward" element={<PurchaseInward />} />
              <Route path="inward/create" element={<CreatePurchaseInward />} />
              <Route path="return" element={<PurchaseReturn />} />
              <Route path="return/create" element={<CreatePurchaseReturn />} />
            </Route>

            {/* Production Module Routes */}
            <Route path="/production" element={<ProductionScreen />}>
              <Route index element={<Jobslips />} />
              <Route path="jobslips" element={<Jobslips />} />
              <Route path="jobslips/create" element={<CreateJobslip />} />
              <Route path="jobslips/edit" element={<CreateJobslip />} />
              <Route path="jobslips/:id" element={<ViewJobslip />} />
              <Route
                path="jobslips/transfer/:id"
                element={<TransferJobslip />}
              />
              <Route path="jobslips/receive/:id" element={<ReceiveJobslip />} />
              <Route path="design-recipe" element={<DesignRecipe />} />
              <Route path="design-recipe/view" element={<ViewDesignRecipe />} />
              <Route path="karigar" element={<Karigar />} />
              <Route path="create-jobslip" element={<CreateJobslip />} />
              <Route path="materials" element={<Material />} />
              <Route path="materials/add" element={<AddMaterial />} />
              <Route path="materials/view/:id" element={<ViewMaterial />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Page404 />} />
      </Route>
    </Routes>
  );

  // If useExistingRouter is true, don't create a new BrowserRouter
  return useExistingRouter ? (
    <NavigatorContent />
  ) : (
    <BrowserRouter>
      <NavigatorContent />
    </BrowserRouter>
  );
}
